import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';

import { isAuthenticated, useAuth } from '../../contexts/AuthContext';
import { useThemeMode } from '../../contexts/ThemeContext';
import LeftNavBar from '../leftnavbar/LeftNavBar';
import { Link, useNavigate } from "react-router-dom";
import { AppName, DefaultAvatar, LogoLargeScreen, LogoSmallScreen } from '../../constants/Constants';
import { Avatar, Divider } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';


function Header() {
    const [openNav, setOpenNav] = React.useState(null);
    const [openUserMenu, setOpenUserMenu] = React.useState(null);
    const { user, logout } = useAuth();
    const { mode, toggleTheme, setTheme } = useThemeMode();

    const handleNavVisibility = (event) => {
        if (openNav != null) {
            setOpenNav(null)
        } else {
            setOpenNav(event.currentTarget);
        }
    };
    const handleOpenUserMenu = (event) => {
        event.preventDefault();
        setOpenUserMenu(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setOpenUserMenu(null);
    };

    const navigate = useNavigate();
    const loggedIn = isAuthenticated();
    const homeLink = loggedIn ? '/app' : '/';

    const handlelogout = (e) => {
        logout(user)
        setOpenUserMenu(null)
        navigate('/app', { replace: true })
    }

    return (
        <AppBar 
          position="fixed" 
          elevation={0}
          sx={{ 
            zIndex: (theme) => theme.zIndex.drawer + 1,
            background: (theme) => {
              return `linear-gradient(135deg, rgba(0, 151, 167, 0.95) 0%, rgba(0, 188, 212, 0.9) 50%, rgba(0, 151, 167, 0.95) 100%)`;
            },
            boxShadow: (theme) => {
              return '0 4px 20px rgba(0, 188, 212, 0.25)';
            },
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 0,
          }}
        >
            <Container maxWidth="100%" >
                <Toolbar disableGutters>
                    {user ? (
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleNavVisibility}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Box>
                                {openNav ?
                                    (<LeftNavBar open={true} closeNav={() => setOpenNav(null)}></LeftNavBar>) :
                                    (<LeftNavBar open={false} closeNav={() => setOpenNav(null)}></LeftNavBar>)
                                }
                            </Box>

                        </Box>
                    ) : (
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
                        </Box>
                    )}

                    <Box
                        component={Link}
                        to={homeLink}
                        aria-label={loggedIn ? 'Go to app home' : 'Go to home'}
                        sx={{ color: 'inherit', display: { xs: 'flex', md: 'flex', lg: 'none' }, alignItems: 'center', textDecoration: 'none' }}
                    >
                        {LogoSmallScreen}
                    </Box>
                    <Typography
                        variant="h5"
                        noWrap
                        component={Link}
                        to={homeLink}
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'flex', lg: 'none' },
                            flexGrow: 1,
                            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
                            fontWeight: 700,
                            fontSize: '1.5rem',
                            letterSpacing: '0.01em',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        {AppName}
                    </Typography>


                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'none', lg: 'flex' } }}>
                    </Box>
                    <Box
                        component={Link}
                        to={homeLink}
                        aria-label={loggedIn ? 'Go to app home' : 'Go to home'}
                        sx={{ color: 'inherit', display: { xs: 'none', md: 'none', lg: 'flex' }, alignItems: 'center', textDecoration: 'none' }}
                    >
                        {LogoLargeScreen}
                    </Box>
                    <Typography
                        variant="h5"
                        noWrap
                        component={Link}
                        to={homeLink}
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'none', lg: 'flex' },
                            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
                            fontWeight: 700,
                            fontSize: '1.75rem',
                            letterSpacing: '0.01em',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        {AppName}
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'none', lg: 'flex' } }}>
                    </Box>
                    {/* Theme Toggle */}
                    <IconButton
                        onClick={toggleTheme}
                        color="inherit"
                        sx={{ mr: 1 }}
                        aria-label="toggle theme"
                    >
                        {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                    </IconButton>
                    {/* TODO: Profile Picture */}
                    {loggedIn ? (
                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar 
                                        sx={{ 
                                            backgroundColor: (theme) => {
                                              if (mode === 'edtech') {
                                                return theme.palette.primary.dark;
                                              }
                                              return theme.palette.mode === 'dark' 
                                                ? theme.palette.primary.light 
                                                : 'darkblue';
                                            },
                                            color: (theme) => {
                                              if (mode === 'edtech') {
                                                return '#FFFFFF';
                                              }
                                              return theme.palette.mode === 'dark'
                                                ? '#000000'
                                                : 'white';
                                            },
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '1.25rem',
                                            fontWeight: 600,
                                            lineHeight: 1,
                                        }}
                                    >
                                        {user["username"][0].toUpperCase()}
                                    </Avatar>
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ 
                                    mt: '45px',
                                    '& .MuiPaper-root': {
                                        backgroundColor: 'background.paper',
                                    }
                                }}
                                id="menu-appbar"
                                anchorEl={openUserMenu}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(openUserMenu)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem onClick={() => { setOpenUserMenu(null); navigate('/app/profile', { replace: true }) }}>
                                    <Typography sx={{ textAlign: 'center' }}>Profile</Typography>
                                </MenuItem>
                                <MenuItem onClick={(e) => { e.preventDefault(); setOpenUserMenu(null); navigate("/app/feedback") }}>
                                    <Typography sx={{ textAlign: 'center' }}>Contact Us</Typography>
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={handlelogout}>
                                    <Typography sx={{ textAlign: 'center' }}>Logout</Typography>
                                </MenuItem>
                            </Menu>

                        </Box>) : (<></>)
                    }
                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default Header;
